export default __webpack_public_path__ + "static/media/actor.6b1496b9.svg";